import React from 'react';

import Text from 'components/Text';

import styled from 'styled-components';
import { mobile, tablet, useQuery } from 'styles/breakpoints';
import { DynamicImage } from 'components';
import ContinueButton from './QuizContinueButton';

const Container = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  flex-grow: 1;
  max-width: 28.8rem;
  width: 100%;
  padding: 3.5rem 0 7rem;
  @media ${tablet} {
    padding: 1.5rem 1rem 5rem;
  }
`;

const StyledImg = styled(DynamicImage)`
  width: 100%;
  max-width: 28.75rem;
  margin-bottom: 1.25rem;
  @media ${tablet} {
    margin-bottom: 0.75rem;
  }
`;

const RowBox = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 1.25rem;
  width: 100%;
  @media ${tablet} {
    margin-bottom: 0.75rem;
  }
`;

const Description = styled(Text)`
  margin-bottom: 0.75rem;
  color: #000;
  font-size: 1rem;
  @media ${tablet} {
    font-size: 0.875rem;
    margin-bottom: 0.5rem;
  }
`;

const Title = styled(Text)`
  text-align: left;
  color: #000;
  font-size: 1.75rem;
  font-style: normal;
  font-weight: 700;
  line-height: 2.25rem;
  @media ${tablet} {
    font-size: 1.625rem;
    font-style: normal;
    font-weight: 800;
    line-height: 2rem;
  }
`;

const SecondTitle = styled(Title)`
  color: #ef71a0;
`;

const ListContainer = styled.ul`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  align-self: stretch;
  padding-bottom: 3rem;
  list-style: none;
  padding: 0;
  @media ${tablet} {
    padding-bottom: 1.5rem;
  }
`;

const ListItem = styled.span`
  color: #000;
  font-size: 1rem;
  font-weight: 400;
  @media ${tablet} {
    font-size: 0.875rem;
    line-height: 1.375rem;
  }
`;

const Item = styled.li`
  position: relative;
  padding-left: 1.2em;
  &:before {
    content: '•';
    position: absolute;
    left: 0;
    top: 2px;
  }
`;

type InfoImageUnorderedListProps = {
  title?: string;
  secondTitle?: string;
  description?: string;
  list?: string[];
  image?: string;
  nextBtnTitle?: string;
  onContinue: () => void;
};

const InfoImageUnorderedList = ({
  title,
  secondTitle,
  description,
  list,
  onContinue,
  image,
  nextBtnTitle,
}: InfoImageUnorderedListProps) => {
  const { isTablet } = useQuery();

  return (
    <Container>
      {image && <StyledImg src={image} alt="Book image" />}
      <RowBox>
        <Title>{title}</Title>
        <SecondTitle>{secondTitle}</SecondTitle>
      </RowBox>
      <Description>{description}</Description>
      <ListContainer>
        {list?.map((item, i) => (
          <Item key={i}>
            <ListItem dangerouslySetInnerHTML={{ __html: item }} />
          </Item>
        ))}
      </ListContainer>

      <ContinueButton
        title={nextBtnTitle}
        color="primary"
        onClick={onContinue}
        cornerVariant="round"
      />
    </Container>
  );
};

export default InfoImageUnorderedList;
